import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3,9 L3,2 C3,1.44771525 3.44771525,1 4,1 L8.86956522,1 C9.13300396,1 9.38580138,1.10395302 9.57303415,1.28927399 L10.6720803,2.37709802 L20,2.37709802 C20.5522847,2.37709802 21,2.82481327 21,3.37709802 L21,9 L22,9 C22.6077887,9 23.0750324,9.5377097 22.9902149,10.1395511 L21.2857687,22.2338171 C21.2162209,22.7273084 20.7939217,23.094266 20.2955538,23.094266 L3.92354726,23.094266 C3.43189906,23.094266 3.01318427,22.7368835 2.9359601,22.251338 L1.01241285,10.157072 C0.915823617,9.5497691 1.38506399,9 2,9 L3,9 Z M4,11 L3.17161508,11 L4.7770699,21.094266 L19.4266021,21.094266 L20.8491881,11 L20,11 L4,11 Z M19,9 L19,4.37709802 L10.2608696,4.37709802 C9.99743082,4.37709802 9.7446334,4.27314501 9.55740063,4.08782403 L8.45835446,3 L5,3 L5,9 L19,9 z"
  }));
});
var BatchstatusOpen = AbstractIcon.withComponent(Icon);
BatchstatusOpen.displayName = 'BatchstatusOpen';
export default BatchstatusOpen;